<!-- YHCS-order-pay -->

<template>
  <div>去支付 ...</div>
</template>

<script>
import { cookie_get } from "@/util/util";
import { ORDER_TYPE_YHCS } from "@/api/constant";
import { Toast, Dialog } from "vant";

export default {
  created() {
    var yhcs_h5_from_origin = cookie_get("yhcs_h5_from_origin")
    if (yhcs_h5_from_origin && yhcs_h5_from_origin != location.origin) {
      location.href = yhcs_h5_from_origin + location.pathname + location.search
      return
    }
  },

  mounted() {
    this.go_select_card_pay() // 这里未处理 xizang 支付 逻辑
  },

  methods: {
    go_select_card_pay() {
      if (!this.$route.query.YHCS_tradeNo) {
        Dialog.alert({ message: "#19 no query.YHCS_tradeNo" })
        return
      }

      Toast("去支付 ...")

      var _this = this

      this.$router.push({
        path: "/select-card-pay",
        query: {
          cateId: _this.$route.query.cateId,
          goodsType: ORDER_TYPE_YHCS,
          YHCS_tradeNo: _this.$route.query.YHCS_tradeNo,
        }
      })
    }
  }
}
</script>
